import useStateWithChange from '../../shared/hooks/useStateWithChange.ts'
import { useState } from 'react'
import useHttpLoader from '../../shared/hooks/useHttpLoader.ts'
import authApi from './auth.api.ts'
import http, { applyInterceptors } from '../../services/http'
import { useSetRecoilState } from 'recoil'
import authAtom from './auth.atom.ts'
import { useLocation, useNavigate } from 'react-router-dom'
import urls from '../../navigation/urls.ts'
import userAtom from '../User/user.atom.ts'
import ws from '../../services/ws'

const useAuthScreen = () => {
  const { wait, loading } = useHttpLoader()
  const [error, setError] = useState('')
  const [state, _, handleChange] = useStateWithChange({ login: '', password: '', rememberMe: false })
  const { state: locationState } = useLocation()

  const navigate = useNavigate()
  const setAuthValue = useSetRecoilState(authAtom)
  const setUserState = useSetRecoilState(userAtom)

  const handleSubmit = () => {
    wait(authApi.login(state), (resp) => {
      if (resp.status === 'success') {
        setError('')
        applyInterceptors({ ...resp.body.auth, authState: 'authorized' }, setAuthValue, http, 'nsi')
        setAuthValue((prev) => ({
          ...prev,
          authState: 'authorized',
          accessToken: resp.body.auth.accessToken,
          expires: resp.body.auth.expires,
        }))
        setUserState({ ...resp.body.user, accessRights: [], isNotificationsViewed: false })
        ws.connect({ current: { ...resp.body.auth, authState: 'authorized' } })

        if (import.meta.env.MODE === 'development') {
          localStorage.setItem('access', resp.body.auth.accessToken)
        }

        navigate(locationState?.path || urls.home)
      } else {
        setError(resp.message)
      }
    })
  }

  return {
    state,
    loading,
    error,
    handleChange,
    handleSubmit,
  }
}

export default useAuthScreen
